var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRepliconLogoNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    fill: "none",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#1f5ff3",
    strokeDasharray: "1, 1",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 1,
    strokeWidth: 1,
    d: "M76.814 69.362c9.649-2.02 14.828-8.699 14.828-18.77C91.642 38.405 83.197 31 70.135 31H40v64h13.414V70.01h8.705L79.622 95h15.672zm-23.4-11.26V46.32l-10.106-3.308h26.3c5.573 0 8.62 3.223 8.62 7.58 0 4.356-3.047 7.509-8.62 7.509z",
    className: "letter letterR"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRepliconLogoNew);
export default __webpack_public_path__ + "static/media/circleRepliconLogoNew.ca388f7708b361a4548100fa48ff7f29.svg";
export { ForwardRef as ReactComponent };